import React, { useState } from 'react';
import './Login.css';
import Joi from 'joi';
import { useLocation, useNavigate, Location } from 'react-router-dom';

const loginSchema = Joi.object({
	email: Joi.string().email({ tlds: { allow: false } }).required(),
	password: Joi.string().required(),
}).required();

export type LoginNavigationState = {
	from?: string;
}

function Login() {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const navigate = useNavigate();
	const location: Location<LoginNavigationState> = useLocation();

	const onButtonClick = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		const validation = loginSchema.validate({ email, password });

		if (validation.error) {
			setError(validation.error.message);
			return;
		}

		const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ email, password }),
		});

		const data = await res.json();

		if (!res.ok) {
			setError(data.message);
			return;
		}

		console.log(data);

		if (location.state?.from) {
			navigate(location.state.from, { replace: true });
			return;
		} else {
			navigate('/', { replace: true });
		}
	};

	return (
		<div className="Login">
			<div className={'titleContainer'}>
				<div>Login</div>
			</div>
			<br />
			<form action="" onSubmit={onButtonClick}>
				<div className={'inputContainer'}>
					<input
						value={email}
						placeholder="Email"
						onChange={(ev) => setEmail(ev.target.value)}
						className={'inputBox'}
					/>
				</div>
				<div className={'inputContainer'}>
					<input
						value={password}
						placeholder="Password"
						onChange={(ev) => setPassword(ev.target.value)}
						className={'inputBox'}
						type="password"
					/>
				</div>
				<label className="errorLabel">{error}</label>
				<div className={'inputContainer'}>
					<input className={'inputButton'} type="submit" value={'Log in'} />
				</div>
			</form>
		</div>
	);
}

export default Login;
